<template>
  <div>
    <span style="margin-bottom: 10px; display: block">Thông tin tác vụ</span>
    <div class="display-grid" style="background: #F6F6F6; padding: 20px 15px; border-radius: 5px">
      <div class="display-flex__column">
        <span>Mã tác vụ</span>
        <input class="input-style" disabled :value="taskDetail.taskCode"/>
      </div>
      <div class="display-flex__column">
        <span>Tên tác vụ</span>
        <input class="input-style" disabled :value="taskDetail.name"/>
      </div>
      <div class="display-flex__column">
        <span>Loại tác vụ</span>
        <input class="input-style" disabled :value="taskDetail.typeTask"/>
      </div>
      <div class="display-flex__column">
        <span>Hình thức test</span>
        <input class="input-style" disabled :value="taskDetail.typeTest"/>
      </div>
      <div class="display-flex__column">
        <span>Thời gian bắt đầu</span>
        <input class="input-style" disabled :value="taskDetail.startDate"/>
      </div>
      <div class="display-flex__column">
        <span>Thời gian kết thúc</span>
        <input class="input-style" disabled :value="taskDetail.endDate"/>
      </div>
      <div class="display-flex__column">
        <span>Trung tâm</span>
        <input class="input-style" disabled :value="taskDetail.center"/>
      </div>
      <div class="display-flex__column">
        <span>Cơ sở</span>
        <input class="input-style" disabled :value="taskDetail.base"/>
      </div>
      <div class="display-flex__column">
        <span>Họ và tên khách hàng</span>
        <input class="input-style" disabled :value="taskDetail.customerName"/>
      </div>
      <div class="display-flex__column">
        <span>Số điện thoại khách hàng</span>
        <input class="input-style" disabled :value="taskDetail.phone"/>
      </div>
    </div>
    <span :class="taskDetail.bgStatus" style="display: block; padding: 5px 10px; width: fit-content; border-radius: 4px; margin-top: 20px">{{ taskDetail.statusLabel }}</span>
  </div>
</template>

<script>
export default {
  name: "TaskDetailInfo",
  props: {
    taskDetail: {
      type: Object,
      required: true,
      default: {}
    }
  }
}
</script>

<style scoped>
.display-grid {
  gap: 10px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.display-flex__column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.input-style {
  border-radius: 4px;
  padding: 6px 10px;
  background: white;
  border: 1px solid gray;
}
.bg-success {
  background: #1BC5BD;
  color: white;
}

.bg-red-500 {
  background: #C40D0D;
  color: white;
}

.bg-yellow-500 {
  background: #FF9900;
  color: black;
}
</style>
